(() => {
    const sessionKey = 'hdWhatsappBubbleDismissed';
    const widget = document.querySelector('[data-hd-whatsapp-widget]');

    if (!widget) {
        return;
    }

    const bubble = widget.querySelector('[data-hd-whatsapp-bubble]');
    const closeButton = widget.querySelector('[data-hd-whatsapp-close]');

    if (!bubble) {
        return;
    }

    const hideBubble = () => {
        bubble.classList.add('is-hidden');
        bubble.setAttribute('aria-hidden', 'true');
        try {
            window.sessionStorage.setItem(sessionKey, 'true');
        } catch (error) {
            // sessionStorage can be unavailable in strict privacy contexts.
        }
    };

    try {
        if (window.sessionStorage.getItem(sessionKey) === 'true') {
            hideBubble();
            return;
        }
    } catch (error) {
        // Keep the welcome bubble visible when storage cannot be read.
    }

    closeButton?.addEventListener('click', hideBubble);
    window.setTimeout(hideBubble, 6000);
})();
